module.exports = __webpack_public_path__ + "img/heart-full-red.29748a31.svg";